<svelte:options
    customElement={{
    shadow: "none",
    tag: "ofc-wishlist-save-button-v1",
     props: {
      variant: { type: "String", attribute: "variant" },
      variationId: { type: "String", attribute: "variation-id" },
      qualified: { type: "String", attribute: "qualified" },
      source: { type: "String", attribute: "source" },
      ignoreOnex: { type: "Boolean", attribute: "ignore-onex" },
    },
  }}
/>

<script lang="ts">
    import type {WishlistSaveButtonV1Props} from "./index.ts";
    import {
        HeartState,
        executeWishlistAction,
    } from "./WishlistSaveButtonV1.logic.ts";
    import * as wishlist from "@otto-ec/nexus-registry/wishlist";
    import * as onex from "@otto-ec/global-resources/onex";
    import {subscribeToWishlistUpdateEvent} from "./WishlistSaveButtonV1Sync.logic.ts";
    import {onMount} from "svelte";

    const {
        variant = "icon-button-transparent",
        variationId,
        qualified,
        source,
        ignoreOnex
    }: WishlistSaveButtonV1Props = $props();


    let isOnexActive = $state(false);
    let heartState = $state(new HeartState(false));
    /*                                                                                                                   */
    let wishlistLookupVersion = 0;

    onMount(() => {
        void (async () => {
            const onexResult = ignoreOnex
                ? true
                : await onex.isOnexVariantAsync("E3803", "E3803B") || await onex.isOnexVariantAsync("E3803", "E3803C");

            if (onexResult) {
                isOnexActive = true;
            }
        })();
    });

    $effect(() => {
        if (!isOnexActive) {
            return;
        }

        const currentVariationId = variationId;
        const currentQualified = qualified === "true";

        const refreshWishlistState = async () => {
            const currentWishlistLookupVersion = ++wishlistLookupVersion;
            const isOnWishlist = await wishlist.isVariationOnWishlist(currentVariationId, currentQualified);

            /*                                                                */
            if (currentWishlistLookupVersion === wishlistLookupVersion) {
                heartState = heartState.copy({isOnWishlist, triggeredByUser: false});
            }
        };

        const unsubscribe = subscribeToWishlistUpdateEvent(refreshWishlistState);
        void refreshWishlistState();

        return () => {
            wishlistLookupVersion++;
            unsubscribe();
        };
    });

    function handleClick() {
      return executeWishlistAction({
        heartState,
        variationId,
        qualified,
        source,
        setHeartState: (newHeartState) => heartState = newHeartState,
      });
    }

</script>

<!--<div>variationId: {variationId}</div>-->
<!--<div>qualified: {qualified}</div>-->

{#if isOnexActive}
  {#if variant === "icon-button-transparent"}
    <div class="ofc-wishlist-save-button-v1-container">

    {#if !heartState.isOnWishlist}
      <!-- This is a "hack" to achieve a white background for the empty-heart state.
           The icon should be positioned absolutely, with the same dimensions as the icon from oc-icon-button-v3
           (size=100 translates to 24x24px; oc-m-25 translates to margin:4px) -->
      <oc-icon-v1
          class="ofc-wishlist-save-button-v1-fake-icon oc-m-25"
          aria-hidden="true"
          size={"100"}
          type="wishlist-active">
      </oc-icon-v1>
    {/if}

    <oc-icon-button-v3
        onclick={handleClick}
        oc-aria-label={heartState.ariaLabel}
        class="ofc-wishlist-save-button-v1--transparent"
        class:ofc-wishlist-save-button-v1--transparent-empty={!heartState.isOnWishlist}
        class:ofc-wishlist-save-button-v1--transparent-filled={heartState.isOnWishlist}
        icon={heartState.icon}
        size={"50"}
        variant="custom-color-soft">
    </oc-icon-button-v3>

    </div>
  {/if}

  {#if variant === "icon-button-secondary-over-color"}
    <oc-icon-button-v3
        onclick={handleClick}
        oc-aria-label={heartState.ariaLabel}
        class="ofc-wishlist-save-button-v1--secondary-over-color"
        class:ofc-wishlist-save-button-v1--secondary-over-color-empty={!heartState.isOnWishlist}
        class:ofc-wishlist-save-button-v1--secondary-over-color-filled={heartState.isOnWishlist}
        icon={heartState.icon}
        size={"75"}
        variant="custom-color-soft">
    </oc-icon-button-v3>
  {/if}

  {#if variant === "button-secondary"}
    <oc-button-v1
        onclick={handleClick}
        oc-aria-label={heartState.ariaLabel}
        icon-type-left={heartState.isOnWishlist ? "wishlist-active" : "wishlist"}
        size={"100"}
        variant="secondary">
      {heartState.isOnWishlist ? "Artikel gemerkt" : "Artikel merken"}
    </oc-button-v1>
  {/if}

  <style lang="scss">
    @use "@otto-ec/design-tokens/feature-component" as tokens;

    .ofc-wishlist-save-button-v1-container {
      position: relative;
    }

    .ofc-wishlist-save-button-v1-fake-icon {
      --color: #{tokens.$ofc-component-wishlist-save-button-icon-button-transparent-background-icon-color};
      left: 0;
      position: absolute;
      top: 0;
    }

    .ofc-wishlist-save-button-v1--transparent {
      --background-color: #{tokens.$ofc-component-wishlist-save-button-icon-button-transparent-background-color};
    }

    .ofc-wishlist-save-button-v1--transparent-empty {
      --icon-color: #{tokens.$oc-semantic-color-text-default};
    }

    .ofc-wishlist-save-button-v1--transparent-filled {
      --icon-color: #{tokens.$ofc-component-wishlist-save-button-heart-active-color-default};
    }

    .ofc-wishlist-save-button-v1--secondary-over-color {
      --background-color: #{tokens.$oc-semantic-color-background-above};
    }

    .ofc-wishlist-save-button-v1--secondary-over-color-empty {
      --icon-color: #{tokens.$oc-semantic-color-text-default};
    }

    .ofc-wishlist-save-button-v1--secondary-over-color-filled {
      --icon-color: #{tokens.$ofc-component-wishlist-save-button-heart-active-color-default};
    }
  </style>
{/if}
